/**
 * The body-plan registry — validated once, at module load.
 *
 * "Fails validation loudly at load time, not at hit time" (M1-01) is enforced
 * here: importing this module runs every plan through `validateBodyPlan`, so a
 * plan with a missing weight or shares that sum to 0.9 takes down the process
 * at startup with a message naming the part. The alternative is a headless
 * balance run that quietly reports a healthy character gripping at 90%.
 */
import { validateBodyPlan } from '@annwn/sim';
import { BOAR_PLAN } from './boar.js';
import { COW_PLAN, SHEEP_PLAN } from './cattle.js';
import { HUMAN_PLAN } from './human.js';
import { RABBIT_PLAN } from './rabbit.js';
import { STAG_PLAN } from './stag.js';
import { WOLF_PLAN } from './wolf.js';
import { YSGITHYRWYN_PLAN } from './ysgithyrwyn.js';
export { BOAR_PLAN } from './boar.js';
export { COW_PLAN, SHEEP_PLAN } from './cattle.js';
export { HUMAN_PLAN } from './human.js';
export { RABBIT_PLAN } from './rabbit.js';
export { STAG_PLAN } from './stag.js';
export { WOLF_PLAN } from './wolf.js';
export { YSGITHYRWYN_PLAN } from './ysgithyrwyn.js';
export { quadruped } from './quadruped.js';
const PLANS = [
    HUMAN_PLAN,
    WOLF_PLAN,
    STAG_PLAN,
    BOAR_PLAN,
    YSGITHYRWYN_PLAN,
    RABBIT_PLAN,
    COW_PLAN,
    SHEEP_PLAN,
];
for (const plan of PLANS)
    validateBodyPlan(plan);
export const BODY_PLANS = new Map(PLANS.map((plan) => [plan.id, plan]));
/** Throws rather than returning undefined: an unknown plan id is a content bug. */
export function bodyPlan(id) {
    const plan = BODY_PLANS.get(id);
    if (!plan)
        throw new Error(`unknown body plan '${id}'`);
    return plan;
}
//# sourceMappingURL=index.js.map